import { useEffect } from 'react';

import { PrintTechnology } from 'editor/src/store/design/types';
import detectImageTransparencyOperation from 'editor/src/store/gallery/operation/detectImageTransparencyOperation';
import { ImageState, MimeType } from 'editor/src/store/gallery/types';
import { useDispatch, useSelector, useStore } from 'editor/src/store/hooks';

// Checks once each image placed on a DTF spread for a transparent background:
// the DTF background hint stays hidden until that answer is known.
function useImageTransparencyWatcher() {
  const store = useStore();
  const dispatch = useDispatch();
  // the hook runs in App, so with the hint off it subscribes to nothing that changes often
  const enabled = useSelector((state) => !!state.hostSettings.enabledWarnings.DtfImageBackground);
  const designData = useSelector((state) => (enabled ? state.design.designData : undefined));
  const images = useSelector((state) => (enabled ? state.gallery.images : undefined));

  useEffect(() => {
    if (!designData) {
      return;
    }
    const { gallery } = store.getState();
    designData.spreads.forEach((spread) => {
      if (spread.technology !== PrintTechnology.DTF) {
        return;
      }
      spread.pages[0]?.groups.media?.forEach((element) => {
        if (element.type !== 'image' || !element.imageId) {
          return;
        }
        const image = gallery.images.find((img) => img.id === element.imageId);
        if (
          image?.url &&
          image.state === ImageState.UPLOADED &&
          image.type !== MimeType.SVG &&
          image.hasTransparentBackground === undefined
        ) {
          void dispatch(detectImageTransparencyOperation(element.imageId));
        }
      });
    });
  }, [designData, images]);
}

export default useImageTransparencyWatcher;
